import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import { CellForMediaName } from '@pages/person-media/search/columns/person-media/utils';
import { ProvideEdit } from '@components/deal-parent-child-panel';
import { DraggableRowsTable } from '@components/draggable-rows-table';
import * as mediaService from '@api/person-media';
import { map, filter } from 'rxjs/operators';
import { useMountedGetter } from '@lib/common';
import { ImDrawer2 } from 'react-icons/im';
import { ScrollSectionTitle } from '@components/scroll-section-title';
import ContactsIcon from '@material-ui/icons/Contacts';
import { blue } from '@material-ui/core/colors';
import { thumbStack } from '@lib/common/css';
import styled from 'styled-components';

interface PersonMediaSectionProps {
  personVtrId: string;
}

const PersonMediaSection = ({ personVtrId }: PersonMediaSectionProps) => {
 const [loading, setLoading] = useState(false);
  const [mediaList, setMediaList] = useState<any[]>([]);
  const isMounted = useMountedGetter();

  useEffect(() => {
    if (!personVtrId) return;

    setLoading(true);
    const filters = [
      {
        id: 'person_vtr_id',
        value: {
          $eq: personVtrId,
        },
      },
    ];

    const subscription = mediaService
      .filter({
        sortBy: [],
        pageSize: 10,
        page: 1,
        filters,
      })
      .pipe(
        map(res => res.data),
        filter(isMounted)
      )
      .subscribe({
        next: res => {
        //  console.log("response [person-media in person edit]:",res.data)
            const sortedMedia = [...(res.data as any || [])].sort(
              (a, b) => a.order_id - b.order_id
            );

          setMediaList(sortedMedia || []);
          setLoading(false);
        },
        error: err => {
          console.error(err);
          setLoading(false);
        },
      });

    return () => subscription.unsubscribe();
  }, [personVtrId]);


  const columns = useMemo(
    () => [
      {
        Header: 'S.No',
        Cell: ({ row }: any) => row.index + 1,
        width: 60,
      },
      {
        Header: 'Media',
        Cell: CellForMediaName,
        width: 350,
        minWidth: 350,
        maxWidth: 350,
      },
      {
        Header: 'Media Type',
        accessor: 'media_type',
        width: 120,
        minWidth: 120,
      },
      {
        Header: 'Caption',
        accessor: 'media_caption',
        width: 200,
       // minWidth: 200,
      },
     /*   {
        Header: 'Media',
        Cell: CellForMediaName,
        width: 350,
        minWidth: 350,
        maxWidth: 350,
      }, */
    ],
    [],
  );
/* 
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        py={3}
      >
        <CircularProgress />
      </Box>
    );
  } */
const sectionIcon = <ContactsIcon fontSize="large" style={{ color: blue[600] }} />;

 return (
  <Box mt={3}>
    <MediaContainer>
      <Grid item xs={12}>
        <ScrollSectionTitle
          id="content-media"
          subTitle="Information about Content Media"
          icon={sectionIcon}
        >
          Media Details
        </ScrollSectionTitle>
      </Grid>

      <Grid item xs={12}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={3}>
            <CircularProgress />
          </Box>
        ) : mediaList.length ? (
          <Paper className="fixed-height" style={{ width: '100%' }}>
            <DraggableRowsTable
              getRowId={row => row.vtr_id}
              columns={columns}
              data={mediaList}
              onChange={setMediaList}
              stickyHeader
              size="small"
              showDragIcon
              sectionName='person_media'
              person_vtr_id={personVtrId}
            />
          </Paper>
        ) : (
          EmptyContent
        )}
      </Grid>
    </MediaContainer>
  </Box>
);
};

const EmptyContent = (
  <Paper className="fixed-height no-data">
    <span>
      <ImDrawer2 />
      <br />
      <Typography>
       No Media Content.
      </Typography>
    </span>
  </Paper>
);
export default PersonMediaSection;


const MediaContainer = styled.div`
  padding: 10px 5px;
  background: #f5f5f5;
 
  .drag-icon {
    cursor: grab;
  }
  .fixed-height {
    ${thumbStack}
    margin-top: 6px;
    margin-bottom: 6px;
    height: 40vh;
    position: relative;
    overflow: auto;
    .MuiTableContainer-root {
      ${thumbStack}
      height: inherit;
      overflow: inherit;
    }
    &.no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        text-align: center;
        svg {
          font-size: 4em;
          color: #ccc;
        }
      }
    }
  }
`;